module.exports = __webpack_public_path__ + "static/img/case_title.16ab0c88.png";